<template>
  <div class="business-info-full-screen-page">
    <title-bar :title="title" @back="back" show-back></title-bar>
    <rich-scroll ref="$visitScroll" v-if="loaded">
      <div class="form-wrap">
        <soda-form ref="form" v-model="baseData" :config="config" />
      </div>
    </rich-scroll>
    <div class="submit-wrap">
      <rich-button type="submit" @click="confirm">
        {{ gettext('保存') }}
      </rich-button>
    </div>
  </div>
</template>
<script>
import SodaForm from '@/components/form/index'
import TitleBar from '@/components/TitleBar.vue'

import { i18n, getBDCountry } from '@/common/utils/i18n'
import { getLocation } from '@/common/utils/geo'
import {
  initVisit,
  postBusinessInfo,
  getPriceRange
} from '@/api/visit/index.js'
import { configParser, attrAssign } from '@/config/visit/addvisit/methods.js'
import { submitConfig } from '@/config/visit/addvisit/config.js'
import { typeGetBusinessInfoConfig } from '@/config/visit/addvisit/config-business-info.js'
import { getPadInfoConfig } from '@/config/visit/addvisit/config-pad-info.js'

const country = getBDCountry() || 'MX'

const typeToTitle = {
  businessinfo: i18n.gettext('营业信息'),
  businessinfoall: i18n.gettext('营业信息'),
  padinfo: i18n.gettext('门店PAD信息')
}
export default {
  name: 'BusinessInfo',
  components: {
    SodaForm,
    TitleBar
  },
  props: {
    type: {
      required: false,
      type: String,
      default: 'businessinfo'
    },
    shopId: {
      required: true,
      type: [String, Number]
    },
    formData: {
      required: false,
      type: Object,
      default() {
        return null
      }
    },
    useType: {
      required: false,
      type: String,
      default: 'page'
    },
    readPretty: {
      type: Boolean,
      default: false
    }
  },
  inject: ['PRICE_RANGE'],
  data() {
    return {
      title: '',
      loaded: false,
      config: [],
      baseData: {},
      submitToast: null,
      submitLoading: false,
      INNER_PRICE_RANGE: []
    }
  },
  watch: {
    submitLoading(nVal) {
      if (nVal) {
        this.submitToast = this.$createToast({
          type: 'loading',
          time: 0,
          mask: true
        })
        this.submitToast.show()
      } else {
        this.submitToast && this.submitToast.hide()
      }
    }
  },
  computed: {
    _PRICE_RANGE() {
      if (this.PRICE_RANGE && this.PRICE_RANGE.length) {
        return this.PRICE_RANGE
      } else {
        return this.INNER_PRICE_RANGE
      }
    }
  },
  async created() {
    await this.getPriceRange()
    this.init()
  },
  methods: {
    async getPriceRange() {
      if (!(this.PRICE_RANGE && this.PRICE_RANGE.length)) {
        let arr = await getPriceRange()
        this.INNER_PRICE_RANGE.push(...(arr || []))
      }
    },
    async init() {
      let data = this.formData
      this.title = typeToTitle[this.type]

      if (!this.formData) {
        const geo = await getLocation()
        const visitInitInfo = await initVisit({
          shopId: this.shopId,
          lat: geo.lat,
          lng: geo.lng
        })
        data = visitInitInfo.bizoppExt
      }
      data = this.parseData(data)
      Object.assign(this.baseData, data)
      let padDisabled
        = this.baseData.canUpdateIsNeedPad === 0 || this.readPretty

      this.config = this.initConfig(this.type, padDisabled)
      console.log('[log] config =>', this.config)
      this.loaded = true
    },
    initConfig(type, padDisabled) {
      if (type.indexOf('businessinfo') === 0) {
        return configParser(
          typeGetBusinessInfoConfig(type, padDisabled, this._PRICE_RANGE),
          country
        )
      } else if (type === 'padinfo') {
        return configParser(getPadInfoConfig(padDisabled), country)
      }
      return []
    },
    parseData(data) {
      if (!data) return {}
      let obj = Object.assign({}, data)
      let customerPriceRange = ''
      if (this.type !== 'padinfo') {
        if (obj.customerPrice) {
          let min = obj.customerPrice.min || 0
          let max = obj.customerPrice.max || 0
          customerPriceRange = `${min}-${max || '∞'}`
          !this._PRICE_RANGE.includes(customerPriceRange)
            && (customerPriceRange = '')
        }
        obj.customerPrice = customerPriceRange
      }
      if (obj.padExt) {
        Object.assign(obj, obj.padExt)
      }
      if (!obj.isNeedPad) {
        obj.isNeedPad = null
      }
      return obj
    },
    back() {
      this.$emit('back')
    },
    checkBizTime(bizDayTime) {
      // [ { bizDay: [], bizTime: [ { begin: '', end: '' } ] } ]
      if (!bizDayTime) return true
      if (bizDayTime.length > 5) return false
      let unvalidMsg = ''
      let bizDayList = []
      bizDayTime.forEach(item => {
        if (!unvalidMsg) {
          item.bizDay.forEach(bizDayItem => {
            if (!unvalidMsg && bizDayList.includes(bizDayItem)) {
              unvalidMsg = i18n.gettext('营业时间不能重复设置')
            }
          })
          !unvalidMsg && bizDayList.push(...item.bizDay)
        }
        if (!unvalidMsg) {
          item.bizTime.forEach((bizTimeItem, bizTimeIndex) => {
            !unvalidMsg
              && item.bizTime.find((timeItem, timeIndex) => {
                if (bizTimeIndex === timeIndex) return false
                let startTimeRepeat
                  = bizTimeItem.begin <= timeItem.begin
                  && bizTimeItem.end > timeItem.begin
                let endTimeRepeat
                  = bizTimeItem.begin < timeItem.end
                  && bizTimeItem.end >= timeItem.end
                if (startTimeRepeat || endTimeRepeat) {
                  unvalidMsg = i18n.gettext('营业时间段不能重叠')
                  return true
                }
              })
          })
        }
      })

      unvalidMsg
        && this.$createDialog({
          icon: 'richic-important',
          title: unvalidMsg
        }).show()
      return !unvalidMsg
    },
    validate(cb) {
      return this.$refs.form.validate(cb)
    },
    async confirm() {
      // 校验营业时间 是否重复
      if (!this.checkBizTime(this.baseData.bizDayTime)) {
        return
      }
      this.submitLoading = true
      let pass = await this.validate()
      if (!pass) {
        this.submitLoading = false
        return false
      }
      this.addInfo({
        ...this.formatFormData(this.baseData)
      })
    },
    formatFormData(data) {
      let { bizoppExtKeys, padExtKeys } = submitConfig
      let padExt = {}
      let bizoppExt = {
        shopId: this.shopId,
        canUpdateIsNeedPad: data.canUpdateIsNeedPad
      }
      padExtKeys.forEach(attrAssign(data, padExt))
      bizoppExtKeys.forEach(attrAssign(data, bizoppExt))
      Object.keys(padExt).length && (bizoppExt['padExt'] = padExt)
      if (this.type !== 'padinfo') {
        let [min, max] = data.customerPrice.split('-')
        bizoppExt.customerPrice = { min }
        bizoppExt.customerPrice.max = max
        // max !== '∞' && (bizoppExt.customerPrice.max = max)
      }
      return bizoppExt
    },
    addInfo(params) {
      postBusinessInfo(params)
        .then(res => {
          if (res) {
            this.submitLoading = false
            if (this.useType === 'component') {
              this.$emit('confirm', params)
            } else {
              this.showDialog(this.gettext('提交成功'))
            }
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
    showDialog(message) {
      this.$createDialog({
        icon: 'richic-right',
        title: message,
        onConfirm: () => {
          this.$router.go(-1)
        },
        onCancel: () => {}
      }).show()
    }
  }
}
</script>

<style lang="scss">
.business-info-full-screen-page {
  position: relative;
  overflow: hidden;
  height: 100%;
  .form-wrap {
    padding-bottom: 100px;
  }
  .submit-wrap {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 8;
  }

  .rich-loading-spinners {
    margin: 30px auto;
  }

  .rich-form_classic .rich-form-item {
    .rich-checkbox-group,
    .rich-radio-group {
      &::after {
        border: none;
      }
      &::before {
        border: none;
      }
    }
    .rich-form-label {
      padding-bottom: 10px;
    }
    .rich-checkbox-wrap,
    .rich-radio-wrap {
      padding: 5px;
      &::after {
        border: none;
      }
      &:first-child {
        padding-top: 0;
      }
    }
  }
}
</style>
